import React from 'react'
import cn from 'classnames'
import uniqueId from 'lodash/uniqueId'
import Popover from 'react-popover'
import PropTypes from 'prop-types'

import InfoPopover from 'app/components/InfoPopover'

import './styles.scss'
const bc = 'radio-button-notification-type'

const RadioButtonNotificationType = ({
  t,
  radioElements,
  input,
  currentValue,
  showTooltip,
  setFeatureTooltipAsShown,
  label,
  classNameLabel,
  classNameRadioElements,
}) => {
  return (
    <div className={cn(`${bc}`, { [`${classNameRadioElements}`]: !label })}>
      {label && <span className={`${bc}__label-radio-buttons`}>{label}</span>}
      <Popover
        isOpen={showTooltip}
        preferPlace="above"
        place={null}
        tipSize={7}
        body={
          <InfoPopover
            text={t('Please select how you would like us to deliver your activity')}
            action={() => setFeatureTooltipAsShown('smsTooltip')}
          />
        }
      >
        <div className={cn({ [`${bc}__inputs-wrapper`]: !label })}>
          {radioElements.map((el, i) => {
            const id = uniqueId(bc)
            return (
              <label
                htmlFor={id}
                key={i}
                className={cn({
                  [`${bc}__label`]: label,
                  [`${bc}__selected`]: el.value === currentValue,
                  [classNameLabel]: classNameLabel,
                })}
              >
                {t(el.text)}
                <input
                  id={id}
                  type="radio"
                  name={input.name}
                  {...input}
                  value={el.value}
                  checked={el.value === currentValue}
                />
              </label>
            )
          })}
        </div>
      </Popover>
    </div>
  )
}

RadioButtonNotificationType.propTypes = {
  label: PropTypes.string,
  classNameLabel: PropTypes.string,
  classNameRadioElements: PropTypes.string,
}

export default RadioButtonNotificationType
